<template>
  <div class="card-row">
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner5.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>
          Why Choose Century Financial Services for Your Short-Term Loans in
          South Africa
        </h2>
        <p>
          In the complex landscape of financial solutions, short-term loans have
          emerged as a beacon of...
        </p>
        <router-link :to="{ name: 'CompanyNewsArticle1' }"
          >Read more</router-link
        >
      </div>
    </div>

    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner6.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>
          Navigating Century Financial Services's Easy Application Process
        </h2>
        <p>
          In moments of unexpected financial need, it’s important to find a
          swift and straightforward solution...
        </p>
        <router-link :to="{ name: 'CompanyNewsArticle2' }"
          >Read more</router-link
        >
      </div>
    </div>
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner7.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>Stronger Together – The Heartbeat of Success</h2>
        <p>
          In the fast-paced “business machine,” it's easy to get caught up in
          the pursuit of individual success....
        </p>
        <router-link :to="{ name: 'CompanyNewsArticle3' }"
          >Read more</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LimeAllArticle",
  data() {
    return {
      articles: [
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne: "How to Determine If a Short-Term Loan Is Right for You",
          text: `Navigating the financial landscape can be daunting, especially when unexpected expenses arise. Century Financial Services,`,
        },
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne: "Understanding Short Term Loans: The Basics and Benefits",
          text: `In South Africa, a startling statistic revealed that in 2021, 76% of South Africans regularly ran,`,
        },
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne:
            "Tips for Responsible Borrowing: Making the Most of Your Short-Term Loan.",
          text: `Navigating the financial landscape can be daunting, especially when unexpected expenses arise. Century Financial Services,`,
        },
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne: "How to Determine If a Short-Term Loan Is Right for You",
          text: `In South Africa, short-term loans provide immediate financial relief, but they come with significant responsibilities.`,
        },
      ],
    };
  },
  methods: {
    navigateToDetailsPage() {
      // You can navigate programmatically using router.push
      this.$router.push();
    },
  },
};
</script>

<style scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* Adjust as needed */
}

@media only screen and (max-width: 768px) {
  .card-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95vw;
  }

  .card {
    width: 80% !important;
    height: 520px !important;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
}

.card {
  height: 510px;
  overflow: hidden;
  position: relative;
  transition: transform 0.2s ease;
  margin-bottom: 2em;
  border-radius: 0;
  width: calc(50% - 10px);
  margin-bottom: 20px;
  font-size: 15px;
}

.card:hover {
  transform: scale(1.05);
}

.card-image {
  width: 100%;
  height: 350px;
  object-fit: cover;
  width: 100%;
  height: auto;
}

.card-content {
  padding: 20px;
}
</style>
